import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constant } from 'src/app/constant/constant';
import { AuditService } from 'src/app/services/audit.service';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-audit-table',
  templateUrl: './audit-table.component.html',
  styleUrls: ['./audit-table.component.scss']
})
export class AuditTableComponent implements OnInit {

  url = '';
  sanitizedUrl = '';




  @Input() languages: string[];

  @Input() name: any;


  @Input() id: any;

  auditList: any = []
  spinner: boolean;

  constructor(

    private auditService: AuditService, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });


  }

  ngOnInit(): void {


    this.getAuditData();

  }

  columns: any;
  sortParam: any = 'auditId' + "," + Constant.Dsc;
  attributeSetList: any;
  pageSizeValue: any = [];
  search: any;
  filterSelectObj: {};
  elements: any;
  resourcePrivilege: any;
  filterActive: boolean = false;
  serviceUrl: string;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  pageIndex: any;
  pageSize: number;
  pageList: any;


  getAuditData() {
    this.filterActive = false;
    this.spinner = true;

    this.auditService.getAuditData(this.name, this.id, this.page, this.size, this.sortParam).subscribe(
      res => {

        this.auditList = res['content'];
        this.elements = res['numberOfElements'];
        this.auditList.sort = this.sort;
        this.auditList.paginator = this.paginator;
        this.pageList = res['totalElements'];

        this.pageSizeValue = getPageSize(this.pageList)
        this.spinner = false;


      },
      error => {
        this.spinner = false;
      }
    )
  }

  onFilterChangeColumn(event) {


  }


  onFilterChange(event) {


  }

  getUpdate(event) {

  }

  protected _onDestroy = new Subject<void>();

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
